<template>
  <div>
    <el-dialog v-if="isDialog" class="createTaskDialog" ref="dialog" :show="show" :modal="false" top="0px" width="1000px" :title="title"
      :close-on-click-modal="false" :visible.sync="dialogVisible" :append-to-body="false" @opened="opened" @close="cancelDialog">
      <div class="typeTitle" style="text-align: center;">
        <el-radio-group v-model="newTaskType" style="margin-bottom: 10px;">
          <el-radio-button label="0">简版{{title}}</el-radio-button>
          <el-radio-button label="1">复杂{{title}}</el-radio-button>
        </el-radio-group>
      </div>
      <el-scrollbar wrap-class="list" :class="newTaskType==0?'scrollbarHeight2':'scrollbarHeight'" view-style="font-weight: bold;"
        view-class="view-box" :native="false">
        <el-form :model="createTaskMeg" ref="ruleForm" :rules="rules" width="980px" class="createTaskForm demo_ruleForm"
          label-position="right">
          <el-row>
            <el-col :span="24">
              <el-form-item label="标题" label-width="100px" prop="taskName">
                <el-input placeholder="请描述您的问题" v-model="createTaskMeg.taskName">
                  <span slot="suffix" @click="addTag" style="cursor:pointer;color:#409EFF;font-size: 22px;">
                    <el-tooltip content="添加标签" effect="light">
                      <i class="el-input__icon el-icon-circle-plus"></i>
                    </el-tooltip>
                  </span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col style="display: none;">
              <el-form-item label="任务类型" label-width="100px" prop="taskType">
                <el-select style="width: 100%;" v-model="createTaskMeg.taskType" placeholder="请选择类型" @change="taskTypeChange">
                  <el-option v-for="item in taskTypeList " :key="item.ID " :label="item.NAME " :value="item.ID"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="tagArray.length>0">
            <el-col :span="24">
              <el-form-item label="任务标签" label-width="100px" class="rightPadding">
                <TaskTag :tagSource.sync="tagArray" ref="taskTag" :showAddButton="false" :isEmitSave="true"></TaskTag>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="typeInfo.SPECIALTYPE==1">
            <el-col :span="24">
              <el-form-item label="故障地址" label-width="100px" class="rightPadding">
                <selectFuncRoom setWidth="100%" :idArray="FuncRoomId" ref="selectFuncRoom" @getValue="toGetFuncRoomValue"></selectFuncRoom>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="接收方" label-width="100px" :prop="ReceiverProp" class="rightPadding">
                <ayb-select-receiver ref="ReceiveUser" v-model="ReceiveIdArray" :isRadio="true" setWidth="100%"
                  @getValue="receiverGetValue"></ayb-select-Receiver>
              </el-form-item>
            </el-col>
          </el-row>

          <div v-show="newTaskType == 1">
            <el-row>
              <el-col :span="12">
                <el-form-item label="组织名称" label-width="100px">
                  <selectCompanyDept ref="selectDept" :needButton="false" setWidth="100%" :idArray="deptIdArray"
                    @getValue="deptGetValue" :isRadio="true"></selectCompanyDept>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建科室" label-width="100px" class="rightPadding">
                  <el-select v-model="createDeptId" style="width: 100%;" clearable placeholder="请选择" :loading="loading">
                    <el-option v-for="item in createDeptOptions" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="故障类型" label-width="100px">
                  <ayb-select-maintenance v-model="faultTypeIdArray" ref="selectMaintenance" @getValue="mtGetValue"></ayb-select-maintenance>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-show="typeInfo.SPECIALTYPE==1">
                <el-form-item label="任务到期时间" label-width="100px" class="rightPadding">
                  <el-date-picker :disabled="!createTaskMeg.isNotice" type="datetime" v-model="createTaskMeg.overTimeDT"
                    placeholder="请输入任务到期时间"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="text-align: right;line-height: 3;" v-show="typeInfo.SPECIALTYPE==1">
                <el-checkbox label="1" v-model="createTaskMeg.isNotice" ref="isNotice" @change="onNoticeChange" border>进度逾期提醒</el-checkbox>
              </el-col>
            </el-row>
            <el-row v-if="typeInfo.SPECIALTYPE==1 || typeInfo.SPECIALTYPE==3 || typeInfo.SPECIALTYPE==4">
              <el-col :span="24">
                <el-form-item label="选择设备" label-width="100px">
                  <ayb-DeviceObjectList @getValue="getTaskSelectedInstance" v-model="DeviceArr" :taskType="task.TASKTYPE"
                    :isCuoZuo="false"></ayb-DeviceObjectList>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="typeInfo.SPECIALTYPE!=1">
              <el-col :span="12">
                <el-form-item label="预计开始时间" label-width="100px" class="rightPadding">
                  <el-date-picker v-model="createTaskMeg.planStartDT" type="datetime" @change="getPlanStartDT"
                    placeholder="选择日期时间" style="width:100%;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="预计完成时间" label-width="100px" class="rightPadding">
                  <el-date-picker :disabled="!createTaskMeg.isNotice" type="datetime" v-model="createTaskMeg.overTimeDT"
                    placeholder="请输入任务到期时间"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="text-align: right;line-height: 3;">
                <el-checkbox label="1" v-model="createTaskMeg.isNotice" ref="isNotice" @change="onNoticeChange" border>进度逾期提醒</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="接收时长" label-width="100px" class="rightPadding">
                  <el-input v-model="createTaskMeg.firstRemindTime" placeholder="请输入接收时长" ref="firstRemind"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-select v-model="createTaskMeg.firstRemindTimeUnit" placeholder="分" style="width:60px;" ref="firstRemindUnit">
                  <el-option label="分" value="0"></el-option>
                  <el-option label="时" value="1"></el-option>
                  <el-option label="天" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-form-item label="逾期提醒周期" label-width="100px">
                  <el-input :disabled="!createTaskMeg.isRemind" v-model="createTaskMeg.overdueTime" placeholder="请输入逾期提醒周期"
                    style="width:calc(100% - 65px);" ref="overdue"></el-input>
                  <el-select :disabled="!createTaskMeg.isRemind" v-model="createTaskMeg.overdueTimeUnit" placeholder="时"
                    style="width:60px;" ref="overdueUnit">
                    <el-option label="分" value="0"></el-option>
                    <el-option label="时" value="1"></el-option>
                    <el-option label="天" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="text-align:right;">
                <el-checkbox label="1" v-model="createTaskMeg.isRemind" ref="isRemind" @change="onRemindChange" border
                  style="position:relative;top:2px;">操作超期提醒</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="任务等级" label-width="100px" class="rightPadding">
                  <el-select style="width: 100%;" v-model="createTaskMeg.taskLevelSel" placeholder="请选择 ">
                    <el-option v-for="item in taskLevel " :key="item.value " :label="item.label " :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="关注度" label-width="100px">
                  <el-select v-model="createTaskMeg.focusLevelSel" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in focusLevel" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="任务组" label-width="100px" class="rightPadding">
                  <el-row>
                    <el-col :span="20">
                      <selectTaskGroup :taskGroup="TaskGroupId?TaskGroupId:taskGroup" ref="taskGroup" myWidth="100%"
                        @GetTaskGroup="GetTaskGroup"></selectTaskGroup>
                    </el-col>
                    <el-col :span="4">
                      <el-button icon="el-icon-plus" style="height: 40px;margin-top: 2px;border-radius: 0;width: 100%;"
                        @click="taskOpenDialog"></el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建身份" label-width="100px">
                  <el-select style="width: 100%;" v-model="createTaskMeg.createIdentitySel" @change="createIdentityChange"
                    placeholder="请选择">
                    <el-option v-for="item in createIdentity" :key="item.SERVERCENTERID" :label="item.CENTERNAME"
                      :value="item.SERVERCENTERID"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="干系人" label-width="100px" class="rightPadding">
                  <div style="width:calc(100% - 45px);float: left;">
                    <ayb-select-user ref="selectAllUser" v-model="NoticePersonIdArray" :isRadio="false" :size="''"
                      setWidth="100%" @getValue="getAllUser"></ayb-select-user>
                  </div>
                  <div style="float: right;">
                    <el-button type="primary" size="small" icon="el-icon-user-solid" @click="StakeholderClick" circle></el-button>
                  </div>
                </el-form-item>
              </el-col>
              <div>
                <el-col :span="12">
                  <el-form-item label="联系人" label-width="100px" class="rightPadding">
                    <selectLinkman ref="linkman" setWidth="100%" :idArray="linkUserIdArray" :isValidateMethod="false"
                      userNameString="report" :isRadio="true" @getValue="linkmanGetValue"></selectLinkman>
                    <!--<selectAllUserComponent @getValue="linkmanGetValue" :idArray="linkUserIdArray" setWidth="100%" :isContainContact="true"></selectAllUserComponent>-->
                  </el-form-item>
                </el-col>
                <!--<el-col :span="3" style="text-align: right;line-height: 3;">
                                <el-checkbox v-model="createTaskMeg.isEvaluter" label="1" border>评价人</el-checkbox>
                </el-col>-->
              </div>
            </el-row>
          </div>
          <el-row>
            <el-col :span="24">
              <div class="el-form-item__label" style="width: 100px;">
                内容描述
                <br />
                <br />
                <el-button class="myBtn" size="small" icon="el-icon-download" type="success" plain @click="knowledgeList()">知识条目</el-button>
                <br />
                <br />
                <el-button class="myBtn" size="small" icon="el-icon-download" type="success" plain @click="workRecord()">工作记录</el-button>
              </div>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <!--<wangeditor ref="editorTxt" v-model="createTaskMeg.content" @uploader="uploader"></wangeditor>-->
                <ayb-vueupload :fileList="fileViewList" @getValue="fileGetValue" @delValue="fileDelValue" ref="vueUpload">
                  <ayb-uploader-drop>
                    <wangeditor ref="editorTxt" v-model="createTaskMeg.content" @uploader="uploader"></wangeditor>
                    <el-row type="flex">
                      <el-col :span="12">
                        <el-button size="mini" @click="captureStart" style="margin-right:10px" type="primary">截图</el-button>
                        <el-checkbox size="mini" v-model="createTaskMeg.hideWindow">隐藏当前窗口</el-checkbox>
                      </el-col>
                      <el-col :span="12" style="display:flex;align-items: baseline;margin-top:5px">
                        <el-button @click="upload" class="el-button--mini" type="warning">上传附件</el-button>
                        <el-checkbox size="mini" style="margin-left: auto;" v-model="createTaskMeg.NEEDREPLY" border>填写完成备注</el-checkbox>
                      </el-col>
                    </el-row>
                  </ayb-uploader-drop>
                </ayb-vueupload>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">

            </el-col>
          </el-row>
          <el-row v-if="createTaskMeg.resolved">
            <el-col :span="24">
              <el-form-item label="解决方案" label-width="100px">
                <el-input type="textarea" :autosize="{ minRows: 3}" placeholder="请输入解决方案" v-model="createTaskMeg.solution"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
      <div slot="footer" class="dialog-footer">
        <el-row>
          <el-col :span="taskStyle!=0?24:16" :style="taskStyle==0?'text-align:right':'text-align:center'">
            <el-button @click="dialogVisible=false">取 消</el-button>
            <el-button @click="reportStart(taskStyle)" v-if="taskStyle!=0" type="primary">保存</el-button>
            <el-button @click="reportStart(0)" type="primary">{{taskStyle!=0?'生成任务':'发 送'}}</el-button>
            <el-checkbox style="margin-left: 8px;" v-model="createTaskMeg.resolved" border>已解决</el-checkbox>
          </el-col>
          <el-col :span="8" v-if="taskStyle==0" style="text-align:right">
            <el-button @click="reportStart(1)" size="small" type="primary">保存草稿</el-button>
            <el-button @click="reportStart(2)" size="small" type="primary">保存模板</el-button>
          </el-col>
        </el-row>
      </div>
      <workFlowDialog ref="workFlow" @Process="Process"></workFlowDialog>
      <taskDialog ref="taskRelationDialog" :isGroup="true" @getValue="getTask"></taskDialog>
      <knowledgeDialog ref="knowledgeDialog" @getValue="getKnowledge"></knowledgeDialog>
      <workDialog ref="workDialog" @getValue="getWork"></workDialog>
      <StakeholderDialog ref="StakeholderDialog" @getValue="getStakeholder"></StakeholderDialog>
    </el-dialog>
    <div v-else>
      <div class="typeTitle" style="text-align: center;">
        <el-radio-group v-model="newTaskType" style="margin-bottom: 10px;">
          <el-radio-button label="0">简版{{title}}</el-radio-button>
          <el-radio-button label="1">复杂{{title}}</el-radio-button>
        </el-radio-group>
      </div>
      <el-scrollbar wrap-class="list" :class="newTaskType==0?'scrollbarHeight2':'scrollbarHeight'" view-style="font-weight: bold;"
        view-class="view-box" :native="false">
        <el-form :model="createTaskMeg" ref="ruleForm" :rules="rules" width="980px" class="createTaskForm demo_ruleForm"
          label-position="right">
          <el-row>
            <el-col :span="24">
              <el-form-item label="标题" label-width="100px" prop="taskName">
                <el-input placeholder="请描述您的问题" v-model="createTaskMeg.taskName">
                  <span slot="suffix" @click="addTag" style="cursor:pointer;color:#409EFF;font-size: 22px;">
                    <el-tooltip content="添加标签" effect="light">
                      <i class="el-input__icon el-icon-circle-plus"></i>
                    </el-tooltip>
                  </span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col style="display: none;">
              <el-form-item label="任务类型" label-width="100px" prop="taskType">
                <el-select style="width: 100%;" v-model="createTaskMeg.taskType" placeholder="请选择类型" @change="taskTypeChange">
                  <el-option v-for="item in taskTypeList " :key="item.ID " :label="item.NAME " :value="item.ID"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="tagArray.length>0">
            <el-col :span="24">
              <el-form-item label="任务标签" label-width="100px" class="rightPadding">
                <TaskTag :tagSource.sync="tagArray" ref="taskTag" :showAddButton="false" :isEmitSave="true"></TaskTag>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="typeInfo.SPECIALTYPE==1">
            <el-col :span="24">
              <el-form-item label="故障地址" label-width="100px" class="rightPadding">
                <selectFuncRoom setWidth="100%" :idArray="FuncRoomId" ref="selectFuncRoom" @getValue="toGetFuncRoomValue"></selectFuncRoom>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="接收方" label-width="100px" :prop="ReceiverProp" class="rightPadding">
                <ayb-select-receiver ref="ReceiveUser" v-model="ReceiveIdArray" :isRadio="true" setWidth="100%"
                  @getValue="receiverGetValue"></ayb-select-Receiver>
              </el-form-item>
            </el-col>
          </el-row>

          <div v-show="newTaskType == 1">
            <el-row>
              <el-col :span="12">
                <el-form-item label="组织名称" label-width="100px">
                  <selectCompanyDept ref="selectDept" :needButton="false" setWidth="100%" :idArray="deptIdArray"
                    @getValue="deptGetValue" :isRadio="true"></selectCompanyDept>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建科室" label-width="100px" class="rightPadding">
                  <el-select v-model="createDeptId" style="width: 100%;" clearable placeholder="请选择" :loading="loading">
                    <el-option v-for="item in createDeptOptions" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="故障类型" label-width="100px">
                  <ayb-select-maintenance v-model="faultTypeIdArray" ref="selectMaintenance" @getValue="mtGetValue"></ayb-select-maintenance>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-show="typeInfo.SPECIALTYPE==1">
                <el-form-item label="任务到期时间" label-width="100px" class="rightPadding">
                  <el-date-picker :disabled="!createTaskMeg.isNotice" type="datetime" v-model="createTaskMeg.overTimeDT"
                    placeholder="请输入任务到期时间"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="text-align: right;line-height: 3;" v-show="typeInfo.SPECIALTYPE==1">
                <el-checkbox label="1" v-model="createTaskMeg.isNotice" ref="isNotice" @change="onNoticeChange" border>进度逾期提醒</el-checkbox>
              </el-col>
            </el-row>
            <el-row v-if="typeInfo.SPECIALTYPE==1 || typeInfo.SPECIALTYPE==3 || typeInfo.SPECIALTYPE==4">
              <el-col :span="24">
                <el-form-item label="选择设备" label-width="100px">
                  <ayb-DeviceObjectList @getValue="getTaskSelectedInstance" v-model="DeviceArr" :taskType="task.TASKTYPE"
                    :isCuoZuo="false"></ayb-DeviceObjectList>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="typeInfo.SPECIALTYPE!=1">
              <el-col :span="12">
                <el-form-item label="预计开始时间" label-width="100px" class="rightPadding">
                  <el-date-picker v-model="createTaskMeg.planStartDT" type="datetime" @change="getPlanStartDT"
                    placeholder="选择日期时间" style="width:100%;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="预计完成时间" label-width="100px" class="rightPadding">
                  <el-date-picker :disabled="!createTaskMeg.isNotice" type="datetime" v-model="createTaskMeg.overTimeDT"
                    placeholder="请输入任务到期时间"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="text-align: right;line-height: 3;">
                <el-checkbox label="1" v-model="createTaskMeg.isNotice" ref="isNotice" @change="onNoticeChange" border>进度逾期提醒</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="接收时长" label-width="100px" class="rightPadding">
                  <el-input v-model="createTaskMeg.firstRemindTime" placeholder="请输入接收时长" ref="firstRemind"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-select v-model="createTaskMeg.firstRemindTimeUnit" placeholder="分" style="width:60px;" ref="firstRemindUnit">
                  <el-option label="分" value="0"></el-option>
                  <el-option label="时" value="1"></el-option>
                  <el-option label="天" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-form-item label="逾期提醒周期" label-width="100px">
                  <el-input :disabled="!createTaskMeg.isRemind" v-model="createTaskMeg.overdueTime" placeholder="请输入逾期提醒周期"
                    style="width:calc(100% - 65px);" ref="overdue"></el-input>
                  <el-select :disabled="!createTaskMeg.isRemind" v-model="createTaskMeg.overdueTimeUnit" placeholder="时"
                    style="width:60px;" ref="overdueUnit">
                    <el-option label="分" value="0"></el-option>
                    <el-option label="时" value="1"></el-option>
                    <el-option label="天" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="text-align:right;">
                <el-checkbox label="1" v-model="createTaskMeg.isRemind" ref="isRemind" @change="onRemindChange" border
                  style="position:relative;top:2px;">操作超期提醒</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="任务等级" label-width="100px" class="rightPadding">
                  <el-select style="width: 100%;" v-model="createTaskMeg.taskLevelSel" placeholder="请选择 ">
                    <el-option v-for="item in taskLevel " :key="item.value " :label="item.label " :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="关注度" label-width="100px">
                  <el-select v-model="createTaskMeg.focusLevelSel" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in focusLevel" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="任务组" label-width="100px" class="rightPadding">
                  <el-row>
                    <el-col :span="20">
                      <selectTaskGroup :taskGroup="TaskGroupId?TaskGroupId:taskGroup" ref="taskGroup" myWidth="100%"
                        @GetTaskGroup="GetTaskGroup"></selectTaskGroup>
                    </el-col>
                    <el-col :span="4">
                      <el-button icon="el-icon-plus" style="height: 40px;margin-top: 2px;border-radius: 0;width: 100%;"
                        @click="taskOpenDialog"></el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建身份" label-width="100px">
                  <el-select style="width: 100%;" v-model="createTaskMeg.createIdentitySel" @change="createIdentityChange"
                    placeholder="请选择">
                    <el-option v-for="item in createIdentity" :key="item.SERVERCENTERID" :label="item.CENTERNAME"
                      :value="item.SERVERCENTERID"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="干系人" label-width="100px" class="rightPadding">
                  <div style="width:calc(100% - 45px);float: left;">
                    <ayb-select-user ref="selectAllUser" v-model="NoticePersonIdArray" :isRadio="false" :size="''"
                      setWidth="100%" @getValue="getAllUser"></ayb-select-user>
                  </div>
                  <div style="float: right;">
                    <el-button type="primary" size="small" icon="el-icon-user-solid" @click="StakeholderClick" circle></el-button>
                  </div>
                </el-form-item>
              </el-col>
              <div>
                <el-col :span="12">
                  <el-form-item label="联系人" label-width="100px" class="rightPadding">
                    <selectLinkman ref="linkman" setWidth="100%" :idArray="linkUserIdArray" :isValidateMethod="false"
                      userNameString="report" :isRadio="true" @getValue="linkmanGetValue"></selectLinkman>
                    <!--<selectAllUserComponent @getValue="linkmanGetValue" :idArray="linkUserIdArray" setWidth="100%" :isContainContact="true"></selectAllUserComponent>-->
                  </el-form-item>
                </el-col>
                <!--<el-col :span="3" style="text-align: right;line-height: 3;">
                                <el-checkbox v-model="createTaskMeg.isEvaluter" label="1" border>评价人</el-checkbox>
                </el-col>-->
              </div>
            </el-row>
          </div>
          <el-row>
            <el-col :span="24">
              <div class="el-form-item__label" style="width: 100px;">
                内容描述
                <br />
                <br />
                <el-button class="myBtn" size="small" icon="el-icon-download" type="success" plain @click="knowledgeList()">知识条目</el-button>
                <br />
                <br />
                <el-button class="myBtn" size="small" icon="el-icon-download" type="success" plain @click="workRecord()">工作记录</el-button>
              </div>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <!--<wangeditor ref="editorTxt" v-model="createTaskMeg.content" @uploader="uploader"></wangeditor>-->
                <ayb-vueupload :fileList="fileViewList" @getValue="fileGetValue" @delValue="fileDelValue" ref="vueUpload">
                  <ayb-uploader-drop>
                    <wangeditor ref="editorTxt" v-model="createTaskMeg.content" @uploader="uploader"></wangeditor>
                    <el-row type="flex">
                      <el-col :span="12">
                        <el-button size="mini" @click="captureStart" style="margin-right:10px" type="primary">截图</el-button>
                        <el-checkbox size="mini" v-model="createTaskMeg.hideWindow">隐藏当前窗口</el-checkbox>
                      </el-col>
                      <el-col :span="12" style="display:flex;align-items: baseline;margin-top:5px">
                        <el-button @click="upload" class="el-button--mini" type="warning">上传附件</el-button>
                        <el-checkbox size="mini" style="margin-left: auto;" v-model="createTaskMeg.NEEDREPLY" border>填写完成备注</el-checkbox>
                      </el-col>
                    </el-row>
                  </ayb-uploader-drop>
                </ayb-vueupload>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">

            </el-col>
          </el-row>
          <el-row v-if="createTaskMeg.resolved">
            <el-col :span="24">
              <el-form-item label="解决方案" label-width="100px">
                <el-input type="textarea" :autosize="{ minRows: 3}" placeholder="请输入解决方案" v-model="createTaskMeg.solution"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import cap from "@/capturn/capturnwrapper.js";
  import {
    getToken
  } from "../../../util/auth";
  import TaskTag from "./Tag/TaskTag.vue";
  import StakeholderDialog from "./StakeholderDialog.vue";
  import selectKnowledge from "@/components/basicData/selectKnowledge.vue";
  import selectFuncRoom from "@/components/basicData/selectFuncRoom.vue";
  import selectCompanyDept from "@/components/basicData/selectCompanyDeptComponent.vue";
  import selectLinkman from "@/components/basicData/selectLinkmanComponent.vue";
  import selectExcuteHuman from "@/components/basicData/selectExcuteHuman.vue";
  import selectTaskGroup from "@/components/basicData/selectTaskGroup.vue";
  import wangeditor from "@/components/common/editor.vue";
  import selectFacilityComponent from "@/components/basicData/selectFacilityComponent.vue";
  import commonSelectComponent from "@/components/basicData/commonSelectComponent";
  import sde from "@/components/basicData/selectDeviceExample";
  import workFlowDialog from "../components/WorkFlowDialog.vue";
  import knowledgeDialog from "../components/knowledgeDialog";
  import workDialog from "../components/workDialog";
  import {
    MergeFile,
    GetTaskTag
  } from "@/api/modules/basicData/task";
  import {
    GetCustmerSchemeInfoList,
    GetDataItemTree
  } from "@/api/modules/basicData/workFlow";
  import {
    getEventByEventId,
    GetTaskMemeber,
    GetFileInfoByTaskId,
    GetTaskContentByTaskId,
    GetTaskTypeList,
    AddEvent,
    EditEvent,
    GetSysUserByCode,
    workflowCreate,
    AddAssignTask,
    AddAssignFileTask,
    GetCompanyAllGeneralSelTree,
    GetSelfCompanyEx,
    GetAllTaskNoticePolicy,
    getTaskByTaskId
  } from "@/api/modules/basicData/task";
  import {
    GetPubDeptByUserId
  } from "@/api/modules/basicData/user";
  import {
    GetFuncRoomByCompanyId
  } from "@/api/modules/basicData/organization";
  import deviceApi from "@/api/modules/basicData/device";
  const cookieUser = getToken();
  export default {
    name: "CreateTask",
    props: {
      taskGroup: {
        type: String,
        default: ""
      },
      noticePersons: [],
      taskTypeName: "",
      refreshType: {
        //按钮操作成功后刷新方式 0:更新列表 1：刷新页面
        type: Number,
        default: 0
      },
      parentTask: {
        type: Object,
        default: () => null
      },
      groupId: { //群ID
        type: String,
        default: ""
      },
      RelationRecordId: {
        //关联ID
        type: String,
        default: ""
      },
      isDialog:{
        type:Boolean,
        default:true
      }
    },
    components: {
      selectKnowledge,
      selectFuncRoom,
      selectLinkman,
      selectExcuteHuman,
      selectCompanyDept,
      wangeditor,
      selectTaskGroup,
      selectFacilityComponent,
      commonSelectComponent,
      workFlowDialog,
      sde,
      knowledgeDialog,
      workDialog,
      TaskTag,
      StakeholderDialog
    },
    data() {
      var checknum = (rule, value, callback) => {
        value = this.trim(value);
        if (!value) {
          callback(new Error("请描述您的问题"));
          this.time("ruleForm", "taskName");
        } else {
          callback();
        }
      };
      return {
        taskStyle: 0, //类型 0：任务 1：草稿 2：模板
        show: '', //是否显示
        fileViewList: [],
        operationType: 0, //操作类型 0：新增 1：编辑
        isEdit: false, //是否编辑
        typeInfo: {}, //任务类型
        createDeptOptions: [],
        createDeptId: '',
        IsShowOnlyList: this.$route.query.type == "groupList" ? true : false,
        newTaskType: 0,
        tagArray: [], //任务标签
        loading: false,
        tagOptions: [],
        type1: this.$route.query.type || 2,
        isActive: false,
        isRemind: false,
        isNotice: false,
        title: "新建事项",
        ReceiverProp: "ReceiveUserName",
        workflowName: "", //固定流程名称
        type: 1, //类型（1.新建报修，2.服务申请）
        processId: "",
        isWorkFlow: false, //是否走自定义流程
        dialogVisible: false,
        deptIdArray: [],
        ReceiveIdArray: [],
        faultTypeIdArray: [], //故障类型赋值
        NoticePersonIdArray: [], //通知提醒人
        FuncRoomId: [], //故障地址功能间Id
        linkUserIdArray: [], //联系人
        DeviceArr: [], //设备赋值
        TaskGroupId: '', //任务组ID
        moreShow: false, // 显示更多
        createTaskMeg: {
          NEEDREPLY: false, //填写完成备注
          taskName: "", //任务名称
          isEvaluter: true, // 是否是评价人
          resolved: false, // 是否已解决
          content: "", //内容描述
          funcRoom: null, //功能间信息
          man: "",
          overTimeDT: new Date().setTime(new Date().getTime() + 3600 * 1000 * 2),
          proposer: null, // 报告人
          taskLevelSel: "1",
          focusLevelSel: "2",
          createIdentitySel: "0",
          repairTime: [
            new Date(),
            new Date().setTime(new Date().getTime() + 3600 * 1000 * 2)
          ],
          hideWindow: true, // 是否隐藏当前窗口
          taskType: null,
          solution: "",
          linkUser: "", //联系人
          ReceiveUser: {},
          ReceiveUserName: "",
          excuterUser: {}, // 接收人
          DoneDevices: [], //设备
          reportDept: null, // 选择的组织。
          taskGroup: null,
          mech: {
            // 机构信息
            ID: this.companyId,
            NAME: this.companyName
          },
          planStartDT: new Date(),
          planEndDT: new Date().setTime(new Date().getTime() + 3600 * 1000 * 2),
          firstRemindTime: "0",
          overdueTime: "0",
          firstRemindTimeUnit: "0",
          overdueTimeUnit: "0"
        },
        PM_RELATION: [],
        Relation: "",
        rules: {
          taskName: [{
              required: true,
              // message: '请描述您的问题',
              validator: checknum,
              trigger: "blur"
            },
            {
              min: 2,
              max: 50,
              message: "长度在 2 - 50 个字符以内",
              trigger: "blur"
            }
          ],
          ReceiveUserName: [{
            required: true,
            // message: '请选择接收方',
            validator: (rule, value, callback) => {
              value = this.trim(value);
              if (!value) {
                callback(new Error("请选择接收方"));
                this.time("ruleForm", "ReceiveUserName");
              } else {
                callback();
              }
            },
            trigger: "blur"
          }],
          taskType: [{
            required: true
          }]
        },
        taskTypeList: [],
        receiveUserIdArray: [], // 接收方默认的ID
        faultTypeList: [],
        noticePersonList: [],
        fileList: [],
        filePathList: [],
        delFilePathList: [],
        filePanelHeight: {
          height: "60px"
        },
        pickerOptions: {
          shortcuts: [{
              text: "两小时内",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                end.setTime(start.getTime() + 3600 * 1000 * 2);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "一天内",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                end.setTime(start.getTime() + 3600 * 1000 * 24);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "三天内",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                end.setTime(start.getTime() + 3600 * 1000 * 24 * 3);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        },
        taskLevel: [{
            value: "0",
            label: "重要且紧急"
          },
          {
            value: "1",
            label: "重要不紧急"
          },
          {
            value: "2",
            label: "紧急不重要"
          },
          {
            value: "3",
            label: "不重要不紧急"
          }
        ],
        focusLevel: [{
            value: "0",
            label: "不关注"
          },
          {
            value: "1",
            label: "一级关注"
          },
          {
            value: "2",
            label: "二级关注"
          },
          {
            value: "3",
            label: "三级关注"
          }
        ],
        fileFormData: {
          guid: this.Guid()
        },
        isLoad: true
      };
    },
    computed: {
      ...mapState({
        userId: state => state.task.userId,
        ServerCenterIds: state => state.task.ServerCenterIds,
        createIdentity: state => state.task.createIdentity,
        contactId: state => state.user.ContactID,
        realName: state => state.task.realName,
        departmentId: state => state.user.departmentId,
        departmentName: state => state.user.departmentName,
        companyId: state => state.user.companyId,
        companyName: state => state.user.companyName,
        task: state => state.task.curTask,
      }),
      taskLevelNow() {
        return this.createTaskMeg.taskLevelSel;
      },
      // 是否是故障报修类型
      isRepair() {
        return this.createTaskMeg.taskType == "f415c1c0dc62e363";
      },
    },
    mounted() {

    },
    created() {
      cap.Init(this); //初始化截图插件。
    },
    watch: {
      dialogVisible(val) {
        if (val) {
          this.initCreatTaskInfo();
        }
      },
      taskLevelNow(val) {
        GetAllTaskNoticePolicy().then(res => {
          if (!res) return;
          console.log(
            res,
            this.createTaskMeg.firstRemindTime,
            this.createTaskMeg.firstRemindTimeUnit
          );
          const noticeTime = res.filter(item => {
            return item.TASKDEGREE == val;
          });
          this.createTaskMeg.firstRemindTime = noticeTime[0].TIMENUM;
          this.createTaskMeg.firstRemindTimeUnit = noticeTime[0].TIMEUNIT.toString();
        });
      }
    },
    methods: {
      knowledgeList() {
        this.$refs.knowledgeDialog.knowledgeDialogVisible = true
        this.$refs.knowledgeDialog.SearchKnowledge()
      },
      workRecord() {
        this.$refs.workDialog.workDialogVisible = true
        this.$refs.workDialog.getWorkRecord('')
      },
      uploader(files) {
        this.$refs.vueUpload.onFileAdded(files[0]);
      },
      addTag() {
        this.$refs.taskTag.showTagSelect();
      },
      StakeholderClick() {
        this.$refs.StakeholderDialog.OpenDialog(this.noticePersonList);
      },
      getStakeholder(data) { //返回干系人设置负责人关注度数据
        this.noticePersonList = data;
      },
      //知识条目
      getKnowledge(content) {
        this.setAppendContent(this.createTaskMeg.content + content)
      },
      getWork(content) {
        this.setAppendContent(this.createTaskMeg.content + content)
      },
      opened() {
        //console.log('dialog高度：',this.$refs.dialog.$el.offsetHeight);
      },
      OpenDialog(typeInfo, operationType, taskStyle = 0, taskInfo = {}) { //打开新增编辑任务界面 operationType：操作类型 0：新增 1：编辑 2：复制创建 3：生成任务
        switch (operationType) {
          case 1:
            this.isEdit = true;
            this.show = 'ture';
            break;
          case 2:
            this.isEdit = false;
            this.show = 'false';
            const loading = this.$loading({
              lock: true
            });
            break;
          case 3:
            this.isEdit = true;
            this.show = 'false';
            break;
          default:
            this.isEdit = false;
            this.show = 'ture';
            break;
        }
        this.createTaskMeg.isNotice = typeInfo.DELAYNOTICE;
        this.createTaskMeg.overTimeDT = new Date().setTime(new Date().getTime() + 3600 * 1000 * typeInfo.PROCCESSHOUR),
          this.createTaskMeg.repairTime = [
            new Date(),
            new Date().setTime(new Date().getTime() + 3600 * 1000 * typeInfo.PROCCESSHOUR)
          ],
          this.createTaskMeg.taskType = typeInfo.ID;
        this.taskStyle = taskStyle ? taskStyle : 0;
        this.operationType = operationType;
        this.typeInfo = typeInfo;
        console.log('typeInfo', this.typeInfo);
        this.title = typeInfo.NAME;
        if (operationType == 1 || operationType == 2) {
          //编辑
          this.setCreateTaskMeg(taskInfo)
        }
        this.dialogVisible = true;
        // setTimeout(() => {
        //     this.$refs.uploader.initWebUpload();
        // }, 1000);
      },
      upload() {
        this.$refs.vueUpload.openUploader({
          // id: "1111" // 传入的参数
        })
      },
      async setCreateTaskMeg(taskInfo) {
        let item = await getTaskByTaskId(taskInfo.ID, this.userId).then(pmevent => {
          if (!pmevent) {
            this.$store.commit("changeCurTask", {});
            return {}
          } else {
            this.$store.commit("changeCurTask", pmevent);
            return pmevent;
          }
        });
        console.log('setCreateTaskMeg', item);
        if (!item) return;

        this.createTaskMeg = {
          ID: item.ID,
          taskName: item.TASKNAME, //任务名称
          isEvaluter: true, // 是否是评价人
          resolved: item.EXCUTEUSERREPLY ? item.EXCUTEUSERREPLY : false, // 是否已解决
          // funcRoom: null, //功能间信息
          content: '',
          isNotice: item.OVERTIMENOTICE, //进度逾期提醒
          man: "",
          overTimeDT: this.$options.filters["timeFormater"](item.OVERTIME), // item.OVERTIME?new Date(item.OVERTIME).getTime(): new Date().setTime(new Date().getTime() + 3600 * 1000 * 2),
          proposer: null, // 报告人
          taskLevelSel: item.TASKDEGREE.toString(),
          focusLevelSel: item.FOCUSDEGREE.toString(),
          createIdentitySel: item.CREATESERVERCENTERID,
          repairTime: [
            new Date(),
            new Date().setTime(new Date().getTime() + 3600 * 1000 * 2)
          ],
          hideWindow: true, // 是否隐藏当前窗口
          taskType: item.TASKTYPE,
          solution: "",
          linkUser: "", //联系人
          // ReceiveUser: {},
          // ReceiveUserName: "",
          excuterUser: {}, // 接收人
          DoneDevices: [], //设备
          reportDept: null, // 选择的组织。
          taskGroup: null,
          mech: {
            // 机构信息
            ID: this.companyId,
            NAME: this.companyName
          },
          planStartDT: this.$options.filters["timeFormater"](item.BEGINDATE),
          planEndDT: this.$options.filters["timeFormater"](item.ENDDATE),
          firstRemindTime: item.FIRSTRESPONSENUM.toString(),
          overdueTime: item.RESPONSENUM.toString(),
          firstRemindTimeUnit: item.FIRSTRESPONSEUNIT.toString(),
          overdueTimeUnit: item.RESPONSEUNIT.toString(),
          isRemind: item.RESPONSENOTICE,
        }
        if (item.EXCUTEUSERID) {
          this.ReceiveIdArray = [item.EXCUTEUSERID.toString()]
        } else if (item.SERVERCENTERID) {
          this.ReceiveIdArray = [item.SERVERCENTERID]
        }
        console.log('ReceiveIdArray', this.ReceiveIdArray);

        setTimeout(() => {
          this.TaskGroupId = taskInfo.TaskGroupId;
          console.log('CONTENT', item.CONTENT);
          this.$refs.selectFuncRoom.funcRoomName = item.LOCATION; //故障地址

          //接收方
          

          getEventByEventId(item.ID).then(pmevent => {
            if (pmevent) {
              this.deptIdArray = [pmevent.CUSTOMERDEPTID + '-2']
              console.log('CUSTOMERDEPTID', this.deptIdArray);
              this.FuncRoomId = [pmevent.FUNCROOMID]
              console.log('FuncRoomId', pmevent.FUNCROOMID);
              // this.createTaskMeg.focusLevelSel = pmevent.FOCUSDEGREE.toString();
            }
          });

          GetTaskContentByTaskId(item.ID).then(pmevent => {
            if (pmevent) {
              this.setAppendContent(pmevent.CONTENT)
              this.createTaskMeg.content = pmevent.CONTENT;
            }
          });

          GetFileInfoByTaskId(item.ID, 100)
            .then(res => {
              console.log("文件列表：", res);
              // res.forEach(c => {
              //     c._id = c.ID;
              //     c.ID = this.IMGAPI_ROOT + "api/Task/DownloadFileById?id=" + c.ID;
              // });
              this.fileViewList = res;
              // this.loading = false;
            })
            .catch(err => {
              console.log("文件列表获取失败！");
              this.loading = false;
            });

          deviceApi
            .GetTaskDeviceByTaskId(item.ID)
            .then(res => {
              if (res) {
                this.DeviceArr = res.map(function(item) {
                  return item.SOCIALTYPE + "_" + item.SOCIALID;
                });
              }
            })
            .catch(res => {
              console.log(res);
            });

          this.createDeptId = item.CREATEDEPTID //组织机构
          if (item.FaultTypeList.length > 0) {
            this.faultTypeIdArray = [item.FaultTypeList[0].FAULTTYPE + '_' + item.FaultTypeList[0].$id]
          }
          GetTaskMemeber(item.ID, false).then(res => {
            if (!res) return;
            let arrMemeber = [];
            res.forEach(v => {
              arrMemeber.push('0_' + v.USERID); //v.USERTYPE+
            });
            this.NoticePersonIdArray = arrMemeber;
          });
          // this.NoticePersonIdArray = item.NOTICEUSERID ? ['0_' + item.NOTICEUSERID, '1_' + item.NOTICEUSERID] : [];
          this.linkUserIdArray = item.LINKMAN ? [item.LINKMAN] : [];

          if (this.operationType == 2) {
            setTimeout(() => {
              this.reportStart(2)
            }, 1000)
          }
        }, 600)
      },
      taskOpenDialog() {
        this.$refs.taskRelationDialog.dialogVisible = true;
      },
      getTask(arr) {
        console.log("arr", arr);
        if (arr.length > 0) {
          let info = arr[0];
          // this.$refs.taskRelationDialog.taskGroupName=info.EVENTNAME

          this.createTaskMeg.taskGroup = {
            Memo: "",
            Name: info.EVENTNAME,
            ParentValue: "",
            Value: info.EVENTID,
            value: info.EVENTNAME
          };
          this.$refs.taskGroup.taskGroupInfo = this.createTaskMeg.taskGroup;
          console.log("taskGroup", this.createTaskMeg.taskGroup);
        } else {}
      },
      // 标题
      getValueSelectKnowledge(val) {
        this.createTaskMeg.taskName = val;
      },
      getTagByInput(query) {
        if (query !== "") {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            GetTaskTag(query).then(list => {
              this.tagOptions = list.filter(item => {
                return (
                  item.TAGNAME.toLowerCase().indexOf(query.toLowerCase()) > -1
                );
              });
            });
          }, 200);
        } else {
          this.tagOptions = [];
        }
      },
      getAllUser(val) {
        // 选择人员
        console.log('noticePersonList', val);
        val.forEach(item => {
          let info = this.noticePersonList.find(v => v.Key == item.Key);
          if (info) {
            // item=info
            item.USERNAME = item.USERNAME
            item.ISNOTICEPERSON = item.ISNOTICEPERSON,
              item.ALLOWCREATESUBTASK = item.ALLOWCREATESUBTASK,
              item.ISEVALUTIONPERSON = item.ISEVALUTIONPERSON,
              item.FIXEDMEMEBER = item.FIXEDMEMEBER,
              item.ISMONITOR = item.ISMONITOR,
              item.FOCUSDEGREE = item.FOCUSDEGREE,
              item.DEPTID = item.DEPTID,
              item.DEPTNAME = item.DEPTNAME,
              item.COMPANYID = item.COMPANYID,
              item.COMPANYNAME = item.COMPANYNAME,
              item.USERID = item.USERID,
              item.USERTYPE = item.USERTYPE
          } else {
            item.USERNAME = item.Name,
              item.ISNOTICEPERSON = true,
              item.ALLOWCREATESUBTASK = false,
              item.ISEVALUTIONPERSON = false,
              item.FIXEDMEMEBER = false,
              item.ISMONITOR = false,
              item.FOCUSDEGREE = 0,
              item.DEPTID = item.DeptId,
              item.DEPTNAME = item.DeptName,
              item.COMPANYID = item.CompanyId,
              item.COMPANYNAME = item.CompanyName,
              item.USERID = item.UserId,
              item.USERTYPE = item.Type
          }
        });
        this.noticePersonList = val;
      },
      initCreatTaskInfo() {
        GetPubDeptByUserId(this.userId).then(result => {
          if (result) {
            this.createDeptOptions = result;
            console.log("createDeptOptions", result);
            this.createDeptId = this.departmentId;
          }
        });
        if (!this.ServerCenterIds) {
          this.$store.dispatch("changeServerCenterIds");
        }
        if (!this.createIdentity.length) {
          this.$store.dispatch("GetServerCenterByUserId");
        }
        // 初始化创建任务的信息
        this.tagOptions = [];
        this.tagArray = [];
        // this.createTaskMeg.repairTime = [];
        // this.createTaskMeg.repairTime.push(new Date());
        // this.createTaskMeg.repairTime.push(
        //     new Date().setTime(new Date().getTime() + 3600 * 1000 * 2)
        // );
        // 提醒
        this.createTaskMeg.planStartDT = new Date();
        this.createTaskMeg.planEndDT = new Date().setTime(
          new Date().getTime() + 3600 * 1000 * 2
        );
        this.createTaskMeg.isRemind = false;
        this.createTaskMeg.firstRemindTime = 10;
        this.createTaskMeg.overdueTime = 0;
        this.createTaskMeg.firstRemindTimeUnit = "1";
        this.createTaskMeg.overdueTimeUnit = "0";

        this.createTaskMeg.isNotice = this.typeInfo.DELAYNOTICE;
        this.createTaskMeg.overTimeDT = new Date().setTime(new Date().getTime() + 3600 * 1000 * this.typeInfo.PROCCESSHOUR),
          this.createTaskMeg.repairTime = [
            new Date(),
            new Date().setTime(new Date().getTime() + 3600 * 1000 * this.typeInfo.PROCCESSHOUR)
          ],

          this.deptIdArray = [];
        this.ReceiveIdArray = [];
        this.faultTypeIdArray = []; //故障类型赋值
        this.NoticePersonIdArray = []; //通知提醒人
        this.FuncRoomId = []; //故障地址功能间Id
        this.linkUserIdArray = []; //联系人
        this.DeviceArr = []; //设备赋值
        this.TaskGroupId = this.refreshType == 2 ? this.taskGroup : ""; //任务组ID
        this.createDeptId = this.departmentId;
        this.createTaskMeg.taskLevelSel = "1";
        this.createTaskMeg.focusLevelSel = "2";
        this.createTaskMeg.taskName = "";
        this.createTaskMeg.createIdentitySel = "0";
        this.createTaskMeg.resolved = false;
        this.createTaskMeg.content = "";
        this.createTaskMeg.NEEDREPLY = false;
        this.createTaskMeg.hideWindow = true;
        this.fileViewList = [];
        this.fileList = [];
        this.initTaskType();
        setTimeout(() => {
          // this.$refs.selectFuncRoom.reset();
          // this.$refs.selectDept.reset();
          this.$refs.selectAllUser.reset();
          this.$refs.linkman.initDefaultLink(this.contactId);
          this.$refs.vueUpload.close();
          // this.$refs.taskGroup.reset();
          if (this.operationType == 0) {
          }
          this.$refs.editorTxt.reset();
          this.$refs.taskGroup.GetAllTaskGroup();
          // this.$refs.excuteHuman.reset();
          // this.$refs.Proposer.reset();
        }, 500);
      },
      initTaskType() {
        // 初始化任务类型
        GetTaskTypeList().then(res => {
          if (res.length > 0) {
            this.taskTypeList = res.filter(item => item.CLASSID == "fuwu");
            // var defaultType = this.taskTypeList.filter(a => {
            //     if (this.taskTypeName == "任务组") {
            //         return a.ID == "E9354DE41375";
            //     } else {
            //         return a.ID == "dab7a9f20898f2d8";
            //     }
            // });
            // if (defaultType.length > 0) {
            //     this.createTaskMeg.taskType = defaultType[0].ID;
            // } else {
            //     this.createTaskMeg.taskType = this.taskTypeList[0].ID;
            // }
          }
        });
      },
      taskTypeChange(selVal) {
        console.log("selVal", selVal);
        if (!selVal) return "";
        if (selVal === "dab7a9f20898f2d8") {
          //判断是否是自定义流程
          this.isWorkFlow = true;
        }
        //根据任务类型设置任务超期等设置
        var selectType = this.taskTypeList.filter(a => {
          return a.ID == this.createTaskMeg.taskType;
        })[0];

        this.createTaskMeg.isNotice = selectType.DELAYNOTICE;
        this.createTaskMeg.overTimeDT = new Date().setTime(
          new Date().getTime() + 3600 * 1000 * selectType.PROCCESSHOUR
        );
        this.createTaskMeg.firstRemindTime = selectType.RESPONSEHOUR;
        this.createTaskMeg.firstRemindTimeUnit = 1;
        this.createTaskMeg.overdueTime = selectType.RESPONSEHOUR;
        this.createTaskMeg.overdueTimeUnit = 1;
        // console.log(this.taskTypeList.find(d => d.ID === selVal));
      },
      GetTaskGroup(data) {
        console.info("任务组已选择:", data);
        if (data) {
          this.createTaskMeg.taskGroup = data;
        } else {
          this.createTaskMeg.taskGroup = null;
        }
      },
      toGetFuncRoomValue(data) {
        // 选择完了功能间。
        console.info(data);
        if (data.length > 0) {
          console.log("选择了功能间:" + data[0].NAME);
          console.log('funcRoom', data[0]);
          this.createTaskMeg.funcRoom = data[0];
          this.createTaskMeg.mech = {
            ID: data[0].CompanyExId,
            NAME: data[0].CompanyExName
          };
          // this.$refs.selectDept.reset();
          this.deptIdArray = [];
          this.deptIdArray.push(data[0].DeptId + '-2'); // 赋值到组织
        } else {
          this.createTaskMeg.funcRoom = null;
        }
      },
      deptGetValue(data) {
        // 选择了组织。
        if (data.length > 0) {
          console.log("选择了组织:", data);
          this.createTaskMeg.reportDept = {
            ID: data[0].ID,
            NAME: data[0].Name
          };
        } else {
          this.createTaskMeg.reportDept = null;
        }
      },
      linkmanGetValue(value) {
        // 选择的联系人
        console.log("联系人返回的信息:", value);
        this.createTaskMeg.linkUser = value;
      },
      mtGetValue(value) {
        this.faultTypeList = [];
        this.faultTypeList.push(value);
        console.log("故障类型", value);
      },
      receiverGetValue(value) {
        console.log("receiverGetValue", value);
        if (value) {
            this.createTaskMeg = Object.assign({}, this.createTaskMeg, {
              ReceiveUser: value,
              ReceiveUserName: value.Name
            });
         
        } else {
          this.createTaskMeg = Object.assign({}, this.createTaskMeg, {
            ReceiveUser: {},
            ReceiveUserName: ""
          });
        }
        console.log("ReceiveUser--", this.createTaskMeg.ReceiveUser);
      },
      excuteGetValue(value) {
        // 选择了接收人
        if (value) {
          this.createTaskMeg = Object.assign({}, this.createTaskMeg, {
            excuterUser: value
          });
        } else {
          this.createTaskMeg = Object.assign({}, this.createTaskMeg, {
            excuterUser: {}
          });
        }
      },
      selectProposer(value) {
        // 报告人
        if (value) {
          this.createTaskMeg.proposer = value;
        } else {
          this.createTaskMeg.proposer = null;
        }
      },
      toGetValue(value, callback) {
        //为控件绑定值
        console.log("验证通过");
        console.log("获取的值为");
        console.log(value);
        callback(true);
      },
      SelSetValue(value, callback) {
        GetSelfCompanyEx().then(a => {
          GetCompanyAllGeneralSelTree(a.ID)
            .then(res => {
              for (let i = 0; i < res.length; i++) {
                res[i].AggrID = res[i].SocialId + "_" + res[i].Type;
              }
              callback(res);
            })
            .catch(err => {
              console.log("GetCompanyAllGeneralSelTree err");
            });
        });
      },
      SelGetValue(value, callback) {
        this.createTaskMeg.DoneDevices = value;
        console.log("选择关键字111:", value);
      },
      ShowDownLoad(content) {
        // 未安装插件提示下载
        this.$message({
          type: "warning",
          dangerouslyUseHTMLString: true,
          message: content,
          showClose: true,
          duration: 0
        });
      },
      captureStart() {
        // 截图开始
        cap.StartCapture(this.createTaskMeg.hideWindow, this);
      },
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 / 1024 < 1;
        if (!isLt2M) {
          this.$message.warning("上传单个文件大小不能超过 1G!");
          return;
        }
        this.fileList.push(file);
        return false;
      },
      exceedUpload(file, fileList) {
        this.$message.warning("最多上传五个文件");
      },
      handleChange(file, fileList) {
        console.log(this.fileList);
      },
      setAppendContent(imgHtml) {
        // setTimeout(()=>{
          this.$refs.editorTxt.setContent(imgHtml);
        // },500);
      },
      facilityGetValue(value) {
        // 选择设备
        console.log(value);
      },
      HaveVal(val) {
        return val ? val : "";
      },
      Guid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
          c
        ) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
      },
      workFlowDialog() {
        //选择流程
        this.$refs.workFlow.dialogVisible = true;
        this.$refs.workFlow.title = "选择固定流程";
        this.$refs.workFlow.workflow = {};
        this.GetCustmerSchemeInfoList();
        this.GetDataItemTree();
      },
      TimeFormat(time) {
        var newTime = new Date(time);

        function HaveZero(t) {
          return t < 10 ? "0" + t : t;
        }
        var year = newTime.getFullYear();
        var month = HaveZero(newTime.getMonth() + 1);
        var day = HaveZero(newTime.getDate());
        var hours = HaveZero(newTime.getHours());
        var min = HaveZero(newTime.getMinutes());
        var sec = HaveZero(newTime.getSeconds());
        return `${year}-${month}-${day}T${hours}:${min}:${sec}`;
      },
      GetCustmerSchemeInfoList() {
        GetCustmerSchemeInfoList()
          .then(res => {
            console.log(res);
            if (res) {
              this.$refs.workFlow.SchemeList = this.$refs.workFlow.CustmerSchemeList = res;
            }
          })
          .catch(err => {
            this.$message.error("自定义流程报错" + err);
          });
      },
      getTaskSelectedInstance(data, sourceData) {
        // 任务报修选择的运维对象实例
        console.log("getTaskSelectedInstance", data, sourceData);
        this.createTaskMeg.DoneDevices = sourceData;
      },
      GetDataItemTree() {
        GetDataItemTree("FlowSort")
          .then(res => {
            // console.log(res)
            if (res) {
              this.$refs.workFlow.dataItemTree = res;
            }
          })
          .catch(err => {
            this.$message.error("自定义流程报错" + err);
          });
      },
      Process(row) {
        // this.title = '新建报修' + '-' + row.F_Name;
        this.processId = row.F_Code;
        this.workflowName = row.F_Name;
      },
      tagClose() {
        this.processId = "";
        this.workflowName = "";
      },
      reportStart(taskStyle) { //taskStyle 0:任务 1：草稿 2：模板
        // 开始上报准备
        var reportData = {}; //上报的数据用这个
        reportData.TASKSTYLE = taskStyle; //类型
        if (!this.createTaskMeg.taskName) {
          this.$message.warning("请填写标题!");
          return false;
        }
        if (!this.createTaskMeg.taskName.length > 50) {
          this.$message.warning("标题限制字数为50字!");
          return false;
        }
        var guid = this.Guid();
        const date = new Date();

        if (this.getEdit(taskStyle))
          reportData.ID = this.createTaskMeg.ID
        else
          reportData.ID = guid.replace(/-/g, "").substring(0, 16); // 任务ID

        reportData.CREATESOURCE = 3; // 创建来源
        reportData.CREATEUSERID = reportData.PROPOSERID = this.userId;
        reportData.CREATEUSERNAME = reportData.PROPOSERNAME = this.realName;
        reportData.PROPOSERDEPTID = this.departmentId;
        reportData.PROPOSERDEPTNAME = this.departmentName;

        reportData.CUSTOMERID = this.createTaskMeg.mech.ID; // 客户机构ID
        reportData.CUSTOMERNAME = this.createTaskMeg.mech.NAME; // 客户机构名称
        //创建科室
        reportData.CREATEDEPTID = reportData.CREATEDEPTNAME = reportData.CREATECOMPANYID = reportData.CREATECOMPANYNAME =
          "";
        if (this.createDeptId) {
          let curDeptInfo = this.createDeptOptions.find(item => item.ID == this.createDeptId);
          console.log("curDeptInfo", curDeptInfo);
          reportData.CREATEDEPTID = curDeptInfo.ID;
          reportData.CREATEDEPTNAME = curDeptInfo.NAME;
          reportData.CREATECOMPANYID = curDeptInfo.ORGANIZATIONID;
        }

        //////////////页面数据依次排列
        if (this.createTaskMeg.funcRoom && this.createTaskMeg.funcRoom.ID) {
          //   功能间ID
          reportData.FUNCROOMID = this.createTaskMeg.funcRoom.ID;
        } else {
          reportData.FUNCROOMID = "";
        }
        console.log('this.createTaskMeg.funcRoom', this.createTaskMeg.funcRoom);
        console.log('reportData.LINKADDRESS', this.$refs.selectFuncRoom.funcRoomName)
        reportData.LINKADDRESS = this.$refs.selectFuncRoom.funcRoomName; // 联系地址。
        // if (this.$refs.selectDept.selectedDept.length > 0) {
        //   this.createTaskMeg.reportDept = this.$refs.selectDept.selectedDept[0];
        // }

        if (this.createTaskMeg.reportDept) {
          // 上报组织
          reportData.CUSTOMERDEPTID = this.createTaskMeg.reportDept.ID;
          reportData.CUSTOMERDEPTNAME = this.createTaskMeg.reportDept.NAME;
        }
        var linkUser = this.createTaskMeg.linkUser;
        if (linkUser.ID) {
          //如果是选的联系人。
          reportData.LINKMAN = linkUser.ID; //联系人ID
          if (linkUser.PHONE && linkUser.NAME.indexOf(linkUser.PHONE) != -1) {
            //如果联系人名字里包含了手机号就把手机号设为空
            linkUser.NAME = linkUser.NAME.replace(linkUser.PHONE, "");
          } else {
            //联系人号码
            reportData.LINKPHONE = this.HaveVal(linkUser.PHONE);
          } //联系人名称要特殊处理。
          reportData.LINKMANNAME =
            linkUser.NAME +
            "," +
            this.HaveVal(linkUser.PHONE) +
            "," +
            this.HaveVal(linkUser.POST) +
            "," +
            (linkUser.GRADE ? linkUser.GRADE + "(重要级别)" : "");
        } else {
          reportData.LINKMAN = ""; //手动输入的则自己为准。
          reportData.LINKPHONE = "";
          reportData.LINKMANNAME = linkUser;
        }
        reportData.TASKDEGREE = this.createTaskMeg.taskLevelSel; // 任务重要度

        if (this.createTaskMeg.taskGroup) {
          // 任务组
          reportData.TaskGroupName = this.createTaskMeg.taskGroup.NODENAME;
          reportData.TaskGroupId = this.createTaskMeg.taskGroup.NODEID;
        }
        reportData.FOCUSDEGREE = this.createTaskMeg.focusLevelSel; // 任务关注度
        reportData.NEEDREPLY = this.createTaskMeg.NEEDREPLY; //填写完成备注
        reportData.EVENTNAME = this.createTaskMeg.taskName; // 标题
        reportData.CREATESERVERCENTERID = this.createTaskMeg.createIdentitySel; //创建身份
        // reportData.CREATESERVERCENTERNAME = ident.SERVERCENTERID
        // var ident = this.createTaskMeg.createIdentitySel;

        // if (ident.CENTERNAME == "个人") {
        //     // 创建身份
        //     reportData.CREATESERVERCENTERID = ident.CENTERNAME;
        //     reportData.CREATESERVERCENTERNAME = ident.SERVERCENTERID;
        // }
        ///////选择接收方 / 接收人  开始
        var receiverUser = this.createTaskMeg.ReceiveUser;
        console.log(receiverUser);
        console.log(receiverUser, "receiverUser");
        if (!this.processId && !receiverUser.ID) {
          //!receiverUser.ID && this.type === 1
          this.$message.warning("请选择一个接收方!");
          return false;
        }
        var excuterUser = this.createTaskMeg.excuterUser;
        var selectedExcuteUser = null;
        if (receiverUser.ContactType == 1) {
          // 选择的是运维人员
          selectedExcuteUser = {
            ID: receiverUser.Key,
            NAME: receiverUser.Remarks,
            TELEPHONE: "",
            DEPTID: receiverUser.ParentKey,
            DEPTNAME: receiverUser.ParentName
          };
          reportData.SERVERCENTERID = "";
          reportData.SERVERCENTERNAME = "";
        } else {
          reportData.SERVERCENTERID = receiverUser.Key;
          reportData.SERVERCENTERNAME = receiverUser.Name;
          if (excuterUser && excuterUser.ID) {
            selectedExcuteUser = excuterUser;
          }
        }
        if (selectedExcuteUser) {
          // 接收人赋值。
          reportData.EXCUTEDEPTID = selectedExcuteUser.DEPTID;
          reportData.EXCUTEDEPTNAME = selectedExcuteUser.DEPTNAME;
          reportData.EXCUTEUSERID = selectedExcuteUser.ID;
          reportData.EXCUTEUSERNAME = selectedExcuteUser.NAME;
          reportData.EXCUTEUSERPHONE = selectedExcuteUser.TELEPHONE ?
            selectedExcuteUser.TELEPHONE :
            "";
        } else {
          reportData.EXCUTEDEPTID = reportData.EXCUTEDEPTNAME = reportData.EXCUTEUSERID = reportData.EXCUTEUSERNAME =
            reportData.EXCUTEUSERPHONE =
            "";
        }
        ///////////接收方接收
        if (this.createTaskMeg.taskType) {
          // 任务类型
          var selectType = this.taskTypeList.filter(a => {
            return a.ID == this.createTaskMeg.taskType;
          });
          var taskType = selectType[0];
          reportData.EVENTTYPE = taskType.ID;
          reportData.EVENTCLASS = taskType.CLASSID;
          reportData.EVENTTYPENAME = taskType.NAME;
        }
        if (this.createTaskMeg.resolved) {
          // 如果点了已解决  ->  赋值解决方案。
          reportData.EXCUTEUSERREPLY = this.createTaskMeg.solution;
        }

        if (this.createTaskMeg.resolved && !this.createTaskMeg.solution) {
          //!receiverUser.ID && this.type === 1
          this.$message.warning("请输入解决方案!");
          return false;
        }

        if (this.createTaskMeg.resolved && !selectedExcuteUser) {
          // 勾选了已解决，必须要接收人
          this.$message.warning("请选择接收人!");
          return false;
        }

        reportData.CONTENT = this.createTaskMeg.content; // 报修内容
        var proposer = this.createTaskMeg.proposer;
        if (proposer) {
          reportData.PROPOSERID = proposer.ID;
          reportData.PROPOSERNAME = proposer.NAME;
          reportData.PROPOSERDEPTID = proposer.DEPTID;
          reportData.PROPOSERDEPTNAME = proposer.DEPTNAME;
        }
        reportData.STATE = 0;
        reportData.EFFECTDEGREE = 0;
        reportData.EMERGENCEDREGEE = 0;
        reportData.CREATETIME = date;
        // reportData.REPAIRTIME1 = this.TimeFormat(
        //   this.createTaskMeg.repairTime[0]
        // );
        // reportData.REPAIRTIME2 = this.TimeFormat(
        //   this.createTaskMeg.repairTime[1]
        // );
        // 提醒
        // 计划开始时间 结束时间
        reportData.REPAIRTIME1 = reportData.BEGINDATE = this.TimeFormat(
          this.createTaskMeg.planStartDT
        );
        if (this.createTaskMeg.isNotice) {
          reportData.OVERTIMENOTICE = this.createTaskMeg.isNotice; // 进度逾期提醒

          reportData.REPAIRTIME2 = reportData.ENDDATE = this.TimeFormat(
            this.createTaskMeg.overTimeDT
          );
          reportData.OVERTIME = this.TimeFormat(this.createTaskMeg.overTimeDT); // 任务到期时间
        }
        reportData.RESPONSENOTICE = this.createTaskMeg.isRemind; // 操作超期提醒
        if (!/^\d+$/.test(this.createTaskMeg.firstRemindTime)) {
          this.$message.warning("“接收时长”应为数值");
          return false;
        }
        let firstRemindTime = parseInt(this.createTaskMeg.firstRemindTime);
        reportData.FIRSTRESPONSENUM = firstRemindTime;
        reportData.FIRSTRESPONSEUNIT = this.createTaskMeg.firstRemindTimeUnit;
        if (!/^\d+$/.test(this.createTaskMeg.overdueTime)) {
          this.$message.warning("“逾期提醒周期”应为数值");
          return false;
        }
        let overdueTime = parseInt(this.createTaskMeg.overdueTime);
        reportData.RESPONSENUM = overdueTime;
        reportData.RESPONSEUNIT = this.createTaskMeg.overdueTimeUnit;
        if (this.processId) {
          reportData.WORKFLOWID = this.Guid();
        }
        reportData.DeviceList = [];
        //////处理设备对象相关数据
        if (this.createTaskMeg.DoneDevices.length > 0) {
          // 设备。
          this.createTaskMeg.DoneDevices.forEach(c => {
            c.TASKID = reportData.ID;
            c.NAME = c.Name;
            c.DEVTYPENAME = c.ObjectTypeName;
            c.SOCIALID = c.SocialId;
            c.SOCIALTYPE = c.Type;
            c.OBJID = c.ObjectType;
            c.BRANDCODE = c.BrandCode;
            c.BRANDSHOWNAME = c.BrandName;
            c.SERIAL = c.Serial;
            c.MODE = c.Model;
            c.VERSION = c.Version;
            c.LOCATION =
              (c.Area || "") +
              (c.Building || "") +
              (c.Floor || "") +
              (c.RoomName || "");
            c.Id = 0;
          });
          reportData.DeviceList = this.createTaskMeg.DoneDevices;
        }
        reportData.FaultTypeList = [];
        if (this.faultTypeList.length > 0) {
          // 设备。
          this.faultTypeList.forEach(c => {
            c.TASKID = reportData.ID;
            c.FAULTTYPE = c.ID;
            // c.ID = 0
          });
          this.faultTypeList.forEach(c => {
            c.ID = 0;
            c.Id = 0;
          });
          reportData.FaultTypeList = this.faultTypeList;
        }
        //console.info(reportData)
        //reportData.EVENTDEVICES = [];
        var formData = new FormData();
        // if (this.fileList.length > 0) {
        //   for (var i = 0; i < this.fileList.length; i++) {
        //     formData.append(i.toString(), this.fileList[i].source.source);
        //   }
        // }
        formData.append("FilePathList", JSON.stringify(this.filePathList));
        reportData.TagList = this.tagArray;
        reportData.NoticePersonList = []; //this.noticePersonList; //
        reportData.ChatGroupId = this.groupId;
        if (this.noticePersonList.length > 0) {
          this.noticePersonList.forEach(c => {
            c.TASKID = reportData.ID;
            // reportData.NoticePersonList.push(c);
            reportData.NoticePersonList.push({
              USERID: c.UserId,
              USERNAME: c.Name,
              DEPTID: c.DeptID,
              DEPTNAME: c.DeptName,
              TASKID: reportData.ID,
              ISNOTICEPERSON: c.ISNOTICEPERSON,
              ALLOWCREATESUBTASK: c.ALLOWCREATESUBTASK,
              ISEVALUTIONPERSON: c.ISEVALUTIONPERSON,
              FIXEDMEMEBER: c.FIXEDMEMEBER,
              ISMONITOR: c.ISMONITOR,
              FOCUSDEGREE: c.FOCUSDEGREE,
            });
          });
        }
        if (this.RelationRecordId) {
          reportData.RelationRecordId = this.RelationRecordId;
        }
        reportData.ParentTask = this.parentTask;
        console.log(reportData.NoticePersonList, "通知提醒人");
        if (this.type === 1) {
          formData.append("DeviceList", JSON.stringify(reportData.DeviceList));
          formData.append(
            "FaultTypeList",
            JSON.stringify(reportData.FaultTypeList)
          );
          formData.append(
            "NoticePersonList",
            JSON.stringify(reportData.NoticePersonList)
          );
          formData.append("SolveMySelf", this.createTaskMeg.resolved);
          console.log("reportData", reportData);
          this.PM_RELATION.LINKID = reportData.ID;
          this.PM_RELATION.LINKSTATE = reportData.STATE;
          if (this.Relation === 1) {
            reportData.Relation = this.PM_RELATION;
          }
          formData.append("EventInfo", JSON.stringify(reportData));
          // this.$emit("getValue", reportData)
          const loading = this.$loading({
            lock: true
          });
          setTimeout(() => {
            loading.close();
          }, 8000);
          if (this.getEdit(taskStyle)) {
            formData.append("DelFileIdList", JSON.stringify(this.delFilePathList));
            EditEvent(formData)
              .then(res => {
                loading.close();
                let operationName = '修改';
                let taskStyleName = taskStyle == 1 ? '草稿' : taskStyle == 2 ? "模板" : "";
                if (res == 1) {
                  this.$message({
                    message: operationName + this.title + taskStyleName + "成功!",
                    type: "success"
                  });
                  this.$emit("getValue", reportData);
                  this.initCreatTaskInfo();
                  this.dialogVisible = false;
                } else {
                  this.$message.error(this.title + "失败");
                }
              })
              .catch(err => {
                this.$message.error(this.title + "失败" + err);
              });
          } else {
            AddEvent(formData)
              .then(res => {
                loading.close();
                let operationName = '创建';
                let taskStyleName = taskStyle == 1 ? '草稿' : taskStyle == 2 ? "模板" : "";
                if (res == 1) {
                  this.$message({
                    message: operationName + this.title + taskStyleName + "成功!",
                    type: "success"
                  });
                  this.$emit("getValue", reportData);
                  this.initCreatTaskInfo();
                  this.dialogVisible = false;
                } else {
                  this.$message.error(this.title + "失败");
                }
              })
              .catch(err => {
                this.$message.error(this.title + "失败" + err);
              });
          }
        } else {
          let currentTask = this.$store.state.task.curTask;

          reportData.EVALUTIONTIME = date;
          reportData.PROPOSERID = currentTask.PROPOSERID;
          reportData.PROPOSERNAME = currentTask.PROPOSERNAME;
          reportData.PROPOSERDEPTID = currentTask.PROPOSERDEPTID;
          reportData.PROPOSERDEPTNAME = currentTask.PROPOSERDEPTNAME;
          reportData.PROPOSERCOMPANYID = currentTask.PROPOSERCOMPANYID;
          reportData.PROPOSERCOMPANYNAME = currentTask.PROPOSERCOMPANYNAME;
          reportData.PARENTID = currentTask.ID;
          reportData.EVENTINSTANCE = currentTask.EVENTINSTANCE;
          reportData.EVENTID = currentTask.EVENTID;
          reportData.EVENTNAME = currentTask.EVENTNAME;
          reportData.ROOTID = currentTask.ROOTID;
          reportData.PARENTNAME = currentTask.TASKNAME;
          reportData.TASKNAME = this.createTaskMeg.taskName;
          reportData.BEGINDATE = reportData.REPAIRTIME1;
          reportData.ENDDATE = reportData.REPAIRTIME2;
          let jsonData = {
            USERID: this.userId,
            USERNAME: this.realName,
            DEPTID: this.departmentId,
            DEPTNAME: this.departmentName,
            TASKID: currentTask.ID,
            ISNOTICEPERSON: false,
            ALLOWCREATESUBTASK: true,
            ISEVALUTIONPERSON: true
          };
          formData.append("TaskInfo", JSON.stringify(reportData)); //任务信息
          formData.append("TaskMeMberInfo", JSON.stringify(jsonData)); //子任务信息
          AddAssignFileTask(formData).then(pmevent => {
            if (pmevent === 1) {
              this.$message({
                type: "success",
                message: "添加服务申请成功。"
              });
              this.initCreatTaskInfo();
              if (this.type1 !== "3") this.$store.dispatch("changeTaskSource");
              else this.$store.dispatch("GetTaskGroupTaskList");
              this.dialogVisible = false;
            } else {
              this.$message({
                type: "error",
                message: "添加服务申请失败！"
              });
              this.isDisabled = false;
            }
          });
        }
        // console.log(this.createTaskMeg.ReceiveUser);
        if (this.processId) {
          let auditers = {
            // userId: this.createTaskMeg.ReceiveUser.Key,
            // userName: this.createTaskMeg.ReceiveUser.Name,
          };
          let createUser = {
            userId: this.userId,
            realName: this.realName,
            companyId: this.companyId,
            departmentId: this.departmentId
          };
          workflowCreate(
              true,
              reportData.WORKFLOWID,
              this.processId,
              this.createTaskMeg.taskName,
              1,
              this.createTaskMeg.content,
              JSON.stringify(createUser),
              JSON.stringify(auditers),
              "{}"
            )
            .then(res => {
              if (res.status === 1) {
                this.$message({
                  message: res.desc,
                  type: "success"
                });
              } else {
                this.$message({
                  message: res.desc,
                  type: "error"
                });
              }
            })
            .catch(err => {
              this.$message.error("自定义流程报错" + err);
              console.error(err);
            });
        }
      },
      getEdit(taskStyle) { //是否修改任务
        return this.isEdit && !(this.taskStyle == 2 && taskStyle == 0);
      },
      cancelDialog() {
        this.initCreatTaskInfo();
        if (this.IsShowOnlyList) {
          parent.setFullScreen(false);
        }
      },
      onRemindChange(val) {
        this.createTaskMeg.isRemind = val;
      },
      onNoticeChange(val) {
        this.createTaskMeg.isNotice = val;
      },
      fileGetValue(fileList) { //上传成功的文件
        this.filePathList = fileList;
      },
      fileDelValue(fileList) { //删除的文件
        this.delFilePathList = fileList;
      },
      getPlanStartDT(val) {
        console.log('getPlanStartDT', val);
      },
      createIdentityChange(val) {
        // createIdentitySel
      }
    }
  };
</script>

<style lang="less" scoped>
  /deep/.el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .myBtn {
    padding: 9px;
  }

  .isActiveClass {
    transform: rotate(90deg);
  }

  .createTaskDialog {
    /deep/ .el-dialog__footer {
      padding: 0px 20px 5px 0px;
    }

    /deep/ .el-dialog {
      margin: 0 auto 0px;
    }

    /deep/ .el-dialog__body {
      padding: 0px 5px;
      overflow-y: auto;
    }

    /deep/ .el-dialog__header {
      text-align: left;
      padding: 10px 10px 10px;
    }

    /deep/ .el-col {
      margin-top: 0px;
      // padding-right: 20px;
      padding-left: 10px;
    }

    height: 100%; // overflow: hidden;

    /deep/ .el-form {
      text-align: left;
    }

    /deep/ .el-form-item {
      margin-bottom: 18px;
    }

    .scrollbarHeight2 {
      height: 480px;
    }

    .scrollbarHeight {
      height: 80vh;
    }

    .rightPadding {
      box-sizing: border-box;
      // padding-right: 20px;
    }

    .selectInput {
      display: inline-block;
    }

    .workFlow {
      margin-right: 20px;
      color: red;
      font-size: large;
    }

    // .list {
    //     max-height: 600px;
    // }

    .createTaskForm {
      margin-bottom: 20px;
      width: 99%;
    }

    .el-form-item__content {
      .el-col {
        margin-top: 0px;
        padding-left: 0px;
      }
    }
  }

  .createTaskDialog[show="false"] {
    display: none;
  }

  #CreateTaskFilePicker {
    font-size: 12px;
    line-height: normal;
  }

  .file-panel {
    width: 840px;
    margin-top: 10px;
    box-shadow: 0 2px 12px 1px rgba(0, 0, 0, 0.1);

    >h2 {
      height: 40px;
      line-height: 40px;
      padding: 0 10px;
      border-radius: 4px 4px 0 0;
      border-bottom: 1px solid #ccc;
      background-color: #fff;
    }

    .file-list {
      position: relative;
      height: 60px;
      // overflow-y: auto;
      background-color: rgb(250, 250, 250);
    }

    .file-item {
      position: relative;
      height: 50px;
      line-height: 50px;
      padding: 0 10px;
      border-bottom: 1px solid #ccc;
      background-color: #fff;
      z-index: 1;

      >li {
        display: inline-block;
      }
    }

    .file-item li {
      overflow: hidden;
    }

    .file-type {
      width: 24px;
      height: 24px;
      margin-bottom: 18px;
      vertical-align: -5px;
    }

    .file-name {
      width: 40%;
      margin-left: 10px;
    }

    .fileName {
      overflow: hidden;
      /*内容超出宽度时隐藏超出部分的内容 */
      text-overflow: ellipsis;
      /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
      white-space: nowrap;
      /*不换行 */
    }

    .file-size {
      width: 20%;
    }

    .file-status {
      width: 20%;
    }

    .file-operate {
      width: 10%;

      >a {
        padding: 10px 5px;
        cursor: pointer;
        color: #666;

        &:hover {
          color: #ff4081;
        }
      }
    }

    .file-type[icon="text"] {
      background: url(../../../assets/img/icon/text-icon.png);
    }

    .file-type[icon="video"] {
      background: url(../../../assets/img/icon/video-icon.png);
    }

    .file-type[icon="image"] {
      background: url(../../../assets/img/icon/image-icon.png);
    }

    .progress {
      position: absolute;
      top: 0;
      left: 0;
      height: 50px;
      width: 0;
      background-color: #e2edfe;
      z-index: -1;
    }

    .no-file {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 16px;
    }
  }
</style>
